module.exports = __webpack_public_path__ + "media/components/common/formParts/img/geo-bg-img-bottom-8372948863abe9ccca995b68be5bb250.jpg";